import styled from 'styled-components';
import { Flexer, TFlexerProps } from '../../styles'

const DataP = styled.p`
  font-weight: bold;
  font-size: 18px;
`;

export function PaymentDetail(props: TFlexerProps & {
  value: any
}) {
  return (
    <Flexer
      className='reportingHistoryDataColumnDataCell'
      justifyContent='center'
      size={props.size}
    >
      <DataP>{props.value}</DataP>
    </Flexer>
  )
}